import script from "./PostbackLog.vue?vue&type=script&setup=true&lang=js"
export * from "./PostbackLog.vue?vue&type=script&setup=true&lang=js"

import "./PostbackLog.vue?vue&type=style&index=0&id=6b5e001e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b5e001e"]])

export default __exports__